var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"path-duplicate-action"},[_c('pendo-icon-button',{attrs:{"tooltip":"Copy","icon":"copy"},on:{"click":_vm.duplicateReport}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }